import { OfferResponse } from 'logic/api-models/api-models';

const getIsTutoringSchool = (item?: OfferResponse) => {
  return item && item.hasOwnProperty('tutoringSchool');
};
export default getIsTutoringSchool;
